import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetServerSidePropsContext } from "next";
import { NextPage } from "next";
import DiscussListPage from "components/pages/discuss/List";
import { getServerSession } from "next-auth";
import { authOptions } from "pages/api/auth/[...nextauth]";
import { QueryClient, dehydrate } from "@tanstack/react-query";

interface Props {
  isMobile: boolean;
}

const DiscussList: NextPage<Props> = ({ isMobile }: { isMobile: boolean }) => {
  return <DiscussListPage isMobile={isMobile} />;
};
export default DiscussList;

export async function getServerSideProps({
  locale,
  req,
  res,
}: GetServerSidePropsContext) {
  const session: any = await getServerSession(req, res, authOptions);
  const base = process.env.NEXTAUTH_URL || `http://${req.headers.host}`;
  const email = session?.user?.email || null;

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
        refetchOnWindowFocus: false,
      },
    },
  });

  try {
    const params = new URLSearchParams({ lite: "true" });
    if (email) params.set("email", email);
    await queryClient.prefetchQuery({
      queryKey: ["discuss", "list", email, "lite"],
      queryFn: async () => {
        const response = await fetch(`${base}/api/discuss/list?${params}`);
        if (!response.ok) throw new Error("discuss list fetch failed");
        return response.json();
      },
    });
  } catch (error) {
    console.error("discuss list prefetch failed:", error);
  }

  const dehydratedState = dehydrate(queryClient);
  const cleanDehydratedState = JSON.parse(
    JSON.stringify(dehydratedState, (_key, value) =>
      value === undefined ? null : value
    )
  );

  return {
    props: {
      dehydratedState: cleanDehydratedState,
      ...(await serverSideTranslations(locale as string, ["discuss"])),
    },
  };
}
